module.exports = __webpack_public_path__ + "static/dina_after-cd35280477c33e1947c3a1e28023f16a.png";